import React, { useState } from 'react'; 
import axios from 'axios';
import styles from './Userregistration.module.css';
import logo from '../../shreeohmlogo.png';
import { NavLink, useNavigate } from 'react-router-dom';
import config from '../../config/config';

const UserRegistration = () => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState(''); // ✅ New state
  const [contact, setContact] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    if (password !== confirmPassword) {
      setErrorMsg('Passwords do not match');
      return;
    }

    try {
      const res = await axios.post(`${config.apiBaseUrl}/api/users/register`, {
        email,
        username, // ✅ Include in request
        contact,
        password
      });

      alert(res.data.message);
      navigate('/shreeohm/login');
    } catch (err) {
      setErrorMsg(err.response?.data?.error || 'Registration failed');
    }
  };

  return (
    <div>
      <div className={styles.usrtop}> 
        <NavLink to="/">
          <img src={logo} alt="Shree OHM Logo" className={styles.logo} />
        </NavLink>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <h1 className={styles.title}>Register</h1>
          <form className={styles.form} onSubmit={handleSubmit}>
            {errorMsg && <p className={styles.error}>{errorMsg}</p>}
            
            <div className={styles.inputGroup}>
              <label htmlFor="email">Email</label>
              <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} className={styles.input} required />
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="username">Username</label> {/* ✅ New field */}
              <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} className={styles.input} required />
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="contact">Contact no.</label>
              <input type="tel" id="contact" value={contact} onChange={(e) => setContact(e.target.value)} className={styles.input} required />
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="password">Password</label>
              <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} className={styles.input} required />
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input type="password" id="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className={styles.input} required />
            </div>
            <button type="submit" className={styles.registerButton}>Register</button>
          </form>
          <p className={styles.loginText}>Already have an account ?? <NavLink to="/shreeohm/login" className={styles.loginLink}>Login</NavLink></p>
        </div>
      </div>
    </div>
  );
};

export default UserRegistration;
